import RecapProductList from 'components/Content/Recap/RecapProductList/RecapProductList.f';
import { withRecapProductListBestSellersProps } from 'components/Content/Recap/RecapProductListBestSellers/withRecapProductListBestSellersProps';

export default withRecapProductListBestSellersProps(RecapProductList);
